import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { getUserInfo, getval2Token } from '../../../Login/Auth';
import { ReqCustomerContractList } from '../../../../item/ItemCustomerContract';
import { api_getCustomerContractList } from '../../../../api/apiCustomerContract';
import moment from 'moment';
import { getItemsInfo, getOnlyDate } from '../../../../item/ItemTools';
import { WageType_Arr, ReqCustomerPositionDetail, RespCustomerPositionDetail, WageType0 } from '../../../../item/ItemCustomerPosition';
import { DatePickerInput } from 'rc-datepicker';
import { api_contractorResumeDetail } from '../../../../api/apiResume';
import { RespResumeDetail, RespResumeOtherData, ReqResumeDetail, RespResumeOtherDataBase } from '../../../../item/ItemResume';
import { OtherData_base } from '../ContractorResume/ContractorResumeBase';
import { api_getCustomerPositionDetail } from '../../../../api/apiCustomerPosition';
import { ReqRecruitmentContractorCaseInfo, ReqRecruitmentContractorAdd, CASE_STATUS_RESERVE, ReqCaseInfoText, CASE_STATUS_RESERVE_SHORT_STRING } from '../../../../item/ItemRecruitmentContractor';
import { api_addRecruitmentContractor } from '../../../../api/apiRecruitmentContractor';


export function ReserveSOPStep2({ id, cId, pId, setIsLoading, action }) {
  const [tokenId, setTokenId] = useState("")
  const [resumeId, setResumeId] = useState("")
  const [companyId, setCompanyId] = useState("")
  const [departmentId, setDepartmentId] = useState()
  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  const [userInfo] = useState(getUserInfo())


  const [customerContractList, setCustomerContractList] = useState([])

  const [caseReserveDate, setCaseReserveDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
  const [base, setBase] = useState({})

  const [name, setName] = useState("")
  const [sex, setSex] = useState("")
  const [age, setAge] = useState("")
  const [sexAge, setSexAge] = useState("")
  const [mobile, setMobile] = useState("")
  const [caseOwner, setCaseOwner] = useState("")
  const [caseOwnerName, setCaseOwnerName] = useState("")

  const [signAt, setSignAt] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [customerPosition, setCustomerPosition] = useState("")
  const [isPublic, setIsPublic] = useState("")
  const [job, setJob] = useState("")
  const [shift, setShift] = useState("")
  const [workPlace, setWorkPlace] = useState("")
  const [workAddress, setWorkAddress] = useState("")
  const [jobRequirement, setJobRequirement] = useState("")
  const [jobDemand, setJobDemand] = useState("")
  const [wageType, setWageType] = useState(WageType0)
  const [wageInfo, setWageInfo] = useState("")

  const [laborInsuranceStatusCode, setLaborInsuranceStatusCode] = useState("0") //勞保狀態參數
  const [laborPensionStatusCode, setLaborPensionStatusCode] = useState("0")     //勞退狀態參數
  const [healthInsuranceStatusCode, setHealthInsuranceStatusCode] = useState("0") //健保狀態 參數
  const [groupInsuranceStatusCode, setGroupInsuranceStatusCode] = useState("0")     //團保狀態參數

  const [laborInsuranceType, setLaborInsuranceType] = useState("0")
  const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("0")
  const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("0")

  const [caseComment, setCaseComment] = useState("")

  const [reservError, setReservError] = useState(false)


  useEffect(()=>{
    //console.log(userInfo)
    setCaseOwner(userInfo.accountId)
    setCaseOwnerName(userInfo.nickName)
    setCompanyId(userInfo.companyId)
    setDepartmentId(userInfo.departmentId)
  },[userInfo])

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("recruitmentContractorStatus", id)
      // console.log(obj)
      setResumeId(obj.resumeId)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (resumeId !== undefined && resumeId !== "") {
      var mReqResumeDetail = new ReqResumeDetail({
        resumeId: resumeId,
      })
      getResumeDetail(mReqResumeDetail)
    }
  }, [resumeId])

  useEffect(() => {
    console.log(cId)
    if (cId !== undefined && cId !== customerContractId) {
      setCustomerContractId(cId)
    }
  }, [cId])

  useEffect(() => {
    console.log(pId)
    if (pId !== undefined && pId !== customerPositionId) {
      setCustomerPositionId(pId)
    }
  }, [pId])

  useEffect(()=>{
    console.log("customerContractId, customerPositionId")
    if(customerContractId !== "" && customerPositionId !== ""){
      var mReqCustomerPositionDetail = new ReqCustomerPositionDetail({
        customerPositionId,
        customerContractId
      })
      getCustomerPositionDetail(mReqCustomerPositionDetail)
    }
  },[customerContractId, customerPositionId])

  function getResumeDetail(mReqResumeDetail) {
    setIsLoading(true)
    console.log(mReqResumeDetail)
    api_contractorResumeDetail({
      mReqResumeDetail,
      success: (result) => {
        console.log(result)
        var mRespResumeDetail = new RespResumeDetail({})
        mRespResumeDetail.fromJson(result.info)
        setResumeId(mRespResumeDetail.resumeId)
        //console.log(mRespResumeDetail.resumeDatas.workExperiences)
        //console.log(mRespResumeDetail.resumeDatas.attachment)
        setBase(setResumeOtherData({
          resumeId: mRespResumeDetail.resumeId,
          resumeKey: OtherData_base,
          resumeData: mRespResumeDetail.resumeDatas.base
        }))

        //setOtherData(mRespResumeDetail.otherData)
        console.log(mRespResumeDetail.resumeDatas.base)
        var mRespResumeOtherDataBase = new RespResumeOtherDataBase({ resumeId })
        if (mRespResumeDetail.resumeDatas.base.resumeData !== undefined && mRespResumeDetail.resumeDatas.base.resumeData !== null)
          mRespResumeOtherDataBase.fromJson(mRespResumeDetail.resumeDatas.base.resumeData)
        console.log(mRespResumeOtherDataBase)
        setName(mRespResumeOtherDataBase.name)
        var sex = mRespResumeOtherDataBase.sex === 1 ? "男" : mRespResumeOtherDataBase.sex === 2 ? "女" : ""
        setSex(sex)

        const startDate = moment(mRespResumeOtherDataBase.birthday);
        const endDate = moment(new Date());
        const age = endDate.diff(startDate, 'years');
        setAge(age)
        setSexAge(sex +"/"+ age)

        setMobile(mRespResumeOtherDataBase.mobile)
        setIsLoading(false)
      },
      failure: (err) => {
        //console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err.message,
        }).then(() => {
          window.history.go(-1)
        })
      }
    })
  }
  function setResumeOtherData({ resumeId, resumeKey, resumeData }) {
    if (resumeData === undefined) {
      return new RespResumeOtherData({
        resumeId,
        resumeKey
      })
    }
    return resumeData
  }

  function getCustomerPositionDetail(mReqCustomerPositionDetail) {
    console.log(mReqCustomerPositionDetail)
    api_getCustomerPositionDetail({
      mReqCustomerPositionDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespCustomerPositionDetail = new RespCustomerPositionDetail({})
        mRespCustomerPositionDetail.fromJson(jsonData.detail)
        console.log(mRespCustomerPositionDetail)

        setCompanyName(mRespCustomerPositionDetail.companyName)
        setSignAt(moment(mRespCustomerPositionDetail.signAt).format('YYYY-MM'))
        setCustomerPosition(mRespCustomerPositionDetail.info.job + "/" + mRespCustomerPositionDetail.info.shift + "/" + getItemsInfo({ items: WageType_Arr, val: mRespCustomerPositionDetail.info.wageType }))
        setIsPublic(mRespCustomerPositionDetail.isPublic===1?"是":"否")
        setJob(mRespCustomerPositionDetail.info.job)
        setShift(mRespCustomerPositionDetail.info.shift)
        setWorkPlace(mRespCustomerPositionDetail.info.workPlace)
        setWorkAddress(mRespCustomerPositionDetail.info.workAddress)
        setJobRequirement(mRespCustomerPositionDetail.info.jobRequirement)
        setJobDemand(mRespCustomerPositionDetail.info.jobDemand)
        setWageType(mRespCustomerPositionDetail.info.wageType)
        setWageInfo(mRespCustomerPositionDetail.info.wageInfo)
        setLaborInsuranceType(mRespCustomerPositionDetail.info.laborInsuranceType)
        setLaborInsuranceLevel(mRespCustomerPositionDetail.info.laborInsuranceLevel)
        setHealthInsuranceLevel(mRespCustomerPositionDetail.info.healthInsuranceLevel)

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toSearch() {
    if (companyName === "")
      return
    var mReqCustomerContractList = new ReqCustomerContractList({ companyId, start: 0, limit: 1000 })
    mReqCustomerContractList.companyName = companyName
    mReqCustomerContractList.contractStatus = '1'
    getCustomerContractList(mReqCustomerContractList)
  }

  function getCustomerContractList(mReqCustomerContractList) {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    //console.log("getCustomerContractList")
    //console.log(mReqCustomerContractList)
    api_getCustomerContractList({
      mReqCustomerContractList,
      success: (obj) => {
        console.log(obj)
        setCustomerContractList(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function toCancel() {
    setCompanyName("")
  }

  function toReservation(){
    var atError = []
    if (reservError) {
      atError.push("預定上工日期")
    }
    if (atError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: atError.join(',') + ' 格式有誤, 請確認月日為2位數',
      })
      return
    }
    setIsLoading(true)
    var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({
      caseCreateDate: getOnlyDate(),
      caseReserveDate,
      customerPositionId,
      // caseContractorName: name,
      // caseSexAge: sexAge,
      // caseMobile: mobile,
      caseSignAt: signAt,
      caseCompanyName: companyName,
      caseWorkPlace: workPlace,
      caseWorkAddress: workAddress,
      caseCustomerPosition:customerPosition,
      caseProcessDescription: [new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: getOnlyDate()+ " "+CASE_STATUS_RESERVE_SHORT_STRING })],
      caseComment:caseComment!==""?[new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: caseComment })]:[],

    })
    console.log(mReqRecruitmentContractorCaseInfo)
    var mReqRecruitmentContractorAdd = new ReqRecruitmentContractorAdd({
      companyId,
      departmentId:departmentId, 
      caseContractor: resumeId, 
      caseStatus:CASE_STATUS_RESERVE, 
      caseInfo : JSON.stringify(mReqRecruitmentContractorCaseInfo),
      caseOwner
    })
    console.log(mReqRecruitmentContractorAdd)

    api_addRecruitmentContractor({
      mReqRecruitmentContractorAdd,
      success:(jsonData)=>{
        console.log(jsonData)
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '預約成功',
        }).then(() => {
          action()
        })
      },
      failure:(err)=>{
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  const onChangeCaseReserveDate = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setReservError(true)
    } else {
      setReservError(false)
      setCaseReserveDate(dateString)
    }
  }

  var title = <>
    <span className="text-primary">預定作業 Step 2:</span>
    <span className="text-success">{name}</span>
    <span className="text-primary">預定的工作狀態</span>
  </>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-3">
            <p>請選擇預定上工日期</p>
            <DatePickerInput
              displayFormat='YYYY/MM/DD'
              returnFormat='YYYY-MM-DD'
              onChange={onChangeCaseReserveDate}
              value={caseReserveDate}
              className='my-react-component'
            />
          </div>
          <SingleText title={"性別/年齡"} val={sexAge} />
          <SingleText title={"手機號碼"} val={mobile} />
          <SingleText title={"本次預定專員"} val={caseOwnerName} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約廠商"} val={signAt +" "+ companyName} />
          <SingleText title={"職缺"} val={customerPosition} />
          <SingleText title={"工作地點"} val={workPlace} />
          <SingleText title={"工作地址"} val={workAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞保狀態"} val={"加保中、2019/12/25、28,800"} />
          <SingleText title={"勞退狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"健保狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"團保保狀態"} val={"N/A"} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
          <div className="col-md-12">
              <div className="col-md-2">
                  <p>親愛的招募人員請注意</p>
              </div>
              <div className="col-md-10">
                  <strong>1. 只能預定XX天之內的。--之後再看是不是要“限制” <p></p>
                      2.@Blan 這裡還要看職缺設定/健保設定/是否自行保險，再增加“是否自行健保”的設定欄位。-- 處理保險時候，再增加欄位<p></p>
                      3. 預定作業 SOP 規定只能由 專員自行操作。主管不能代為預定！（如有不可抗力，則有人代為操作預定作業，如何再由 主管以上 進行轉掛作業）
                      
                  </strong>
              </div>
          </div>
      </div>
    </>
  var footer =
    <div className="row text-right ">
          <div className="col-sm-12">
            <CancelSubmitButton cancelAction={toCancel} submitName={"確定預約"} submitAction={toReservation} isRight={true} />
          </div>
    </div>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    </>
  )
}

